module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/faq_hairmakeup_03_sp-4a88da7d3a15e9eaa7ee58fc97527246.png";